module.exports = __webpack_public_path__ + "static/media/Blinky Empty Cart-01.cc168914.png";